import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../commons/Auth';
import { useTranslation } from 'react-i18next';
import { useLoading } from '../../commons/Loading';
import { useAlert } from 'react-alert';
import { NumberParam, useQueryParams, withDefault } from 'use-query-params';
import axios from 'axios';
import MyGiveAndTakeSupplierPresentational from './SupplierPresentational/MyGiveAndTakeSupplierPresentational';
import MyGiveAndTakeAdminPresentational from './AdminPresentational/MyGiveAndTakeAdminPresentational';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const MyGiveAndTake = ({ profile, match = {}, location }) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();
  const [t] = useTranslation();
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();
  const history = useHistory();

  const [giveAndTake, setGiveAndTake] = useState([]);

  const [query, setQuery] = useQueryParams({
    year: withDefault(NumberParam, new Date().getFullYear()),
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
  });

  const { year, limit, offset } = query;

  const fetchGiveAndTake = async () => {
    showLoading();

    try {
      const requestConfig = {
        headers: { Authorization: newToken },
        params: {
          year,
          limit,
          offset,
        },
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/give-and-take/${profile._id}`,
        requestConfig
      );

      setGiveAndTake(response.data || []);
    } catch (error) {
      alert.error(t('COMMON:GENERIC_ERROR'));
    } finally {
      hideLoading();
    }
  };

  function onFilter(queryDiff) {
    if (
      (queryDiff.year && queryDiff.year !== year) ||
      (year && queryDiff.year === '') ||
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  useEffect(() => {
    fetchGiveAndTake();
  }, [year, limit, offset]);

  return [
    'BUILDING_ADMIN_1',
    'BUILDING_ADMIN_2',
    'BUILDING_ADMIN_3',
    'BUILDING_ADMIN_4',
    'BUILDING_ADMIN_5',
    'AGENCY',
    'COMMERCIAL',
    'ASSOCIATION'
  ].includes(profile.type) || profile.superCollab === true ? (
    <MyGiveAndTakeAdminPresentational
      data={giveAndTake}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={1}
      onFilter={onFilter}
      fetchGiveAndTake={fetchGiveAndTake}
      onShowInfo={(anchor) =>
        history.push(
          `/my-give-and-take/info?year=${year}${anchor ? `#${anchor}` : ''}`
        )
      }
      onShowIafs={(anchor) =>
        history.push(
          `/my-give-and-take/iafs?year=${year}${anchor ? `#${anchor}` : ''}`
        )
      }
    />
  ) : (
    <MyGiveAndTakeSupplierPresentational
      data={giveAndTake}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={1}
      onFilter={onFilter}
      fetchGiveAndTake={fetchGiveAndTake}
    />
  );
};

export default MyGiveAndTake;
